module.exports = __webpack_public_path__ + "static/assets/7888069b78c64641c0c2287291e508fc.png";